export function GetFundColor(fundValue: number | undefined) {
  if (!fundValue) return "";
  if (fundValue < 0) return "text-negative";
  return "text-green";
}
